// extracted by mini-css-extract-plugin
export default {"value":"CalculationSection_value__XfVPY","wrapper":"CalculationSection_wrapper__lF5Ws"};